// utils/date.ts
export const startOfMonday = (d: Date | string | number) => {
	const date = new Date(d);
	const day = date.getDay(); // 0=Sun, 1=Mon, ...
	const diff = day === 0 ? -6 : 1 - day; // move back to Monday
	date.setDate(date.getDate() + diff);
	return date;
};

export const addDays = (d: Date, n: number) => {
	const x = new Date(d);
	x.setDate(x.getDate() + n);
	return x;
};

export const parseISODateToMonday = (iso: string | null | undefined) => {
	if (!iso) return null;
	const d = new Date(`${iso}T00:00:00`);
	// force Monday normalisation (defensive):
	const day = d.getDay(); // 0=Sun, 1=Mon
	const diff = day === 0 ? -6 : 1 - day;
	d.setDate(d.getDate() + diff);
	return d;
};

export const toISODate = (d: Date) => {
	const year = d.getFullYear();
	const month = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
};

export const addDaysSafe = (d: Date, days: number) => {
	console.log("[CAL] addDaysSafe input:", { date: d, days });

	const result = new Date(d);
	result.setDate(result.getDate() + days);
	result.setHours(0, 0, 0, 0); // normalize to midnight

	console.log("[CAL] addDaysSafe output:", result);

	return result;
};
